import { Stack, Heading, Text } from '@chakra-ui/react';
import React from 'react';

import { EventTime } from '@/components/EventTime';

interface EventHeaderProps {
  eventName: string;
  eventStartDate: string;
  eventEndDate: string;
}

export const EventHeader: React.FC<EventHeaderProps> = ({
  eventName,
  eventStartDate,
  eventEndDate,
}) => {
  return (
    <Stack spacing="0">
      <Heading size="md">{eventName}</Heading>
      <Text textStyle="compact" color="#333333" fontWeight="normal">
        <EventTime
          startDate={eventStartDate}
          endDate={eventEndDate}
        />
      </Text>
    </Stack>
  );
};